<template>
    <div class="payment-success-card">
        <div class="success-body">
            <div class="success-icon">
                <img src="@/assets/images/check.png" alt="">
            </div>
            <div class="success-message">
                <h4>Payment Completed</h4>
                <p>
                    <span class="d-block">You have successfully paid {{ formatAmount(paymentDetail.amount, paymentDetail.currency) }}</span>
                    <span class="d-block">Paid Using: {{ paymentDetail.payment_method }}</span>
                    <span class="d-block">Payment ID: {{ paymentDetail.transaction_uuid }}</span>
                </p>
            </div>
        </div>
    </div>
</template>
<script>
import { formatAmount } from '../../../lib/currency';

export default {
    name: 'PaymentSuccess',
    props: {
        paymentDetail: {
            type: Object,
            default: () => {}
        }
    },
    methods: {
        formatAmount
    }
}
</script>